export interface ShippingPreset {
  label: string;
  weightGrams: number;
  lengthCm: number;
  widthCm: number;
  heightCm: number;
}

export const SHIPPING_PRESETS: ShippingPreset[] = [
  { label: 'Caja de calzado estándar', weightGrams: 1000, lengthCm: 33, widthCm: 22, heightCm: 14 },
];
